import { useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-decisoes-jud.jpg";
import { Description } from "../../components/Description";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { mapInitialSearch, Response, Search, useDecisions } from "../../hooks/useDecisions";
import { Container } from "../../theme/styles";
import { Form } from "./components/Form";
import { Results } from "./components/Results";
import { Submit } from "./helpers/submit";
import { Modal } from "../../components/Modal";
import mock from "../../mocks/info";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";

function Decisions() {
  usePageTrack();

  const pathname = useLocation().pathname;
  const [results, setResult] = useState<Response|null>(null);
  const [page, setPage] = useState<number>(1);
  const [order, setOrder] = useState<string>('');
  const initialSearch = pathname?.split('/')[2];
  const firstData: Response = useDecisions(initialSearch);
  const firstSearch: Search = { tribunal: [mapInitialSearch(initialSearch)] }
  const [search, setSearch] = useState<Search|null>(initialSearch? firstSearch : null);

  const [clickedInfo, setClickedInfo] = useState(mock);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  async function submit(_search: Search|null, _page: number = 0, _order: string = '') {
    if(!_search) _search = search;
    if(!_page) _page = page;
    if(!_order) _order = order;
    const result = await Submit(_search, _page, _order);
    setResult(result);
    setSearch(_search);
    setPage(_page);
    setOrder(_order);
  }

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Description>
        Mesmo os tribunais disponibilizando as decisões, o trabalho de seleção, sistematização e organização das decisões sobre direitos autorais é tortuoso. Por isso reunimos aqui, inicialmente, todas as decisões colegiadas do Supremo Tribunal Federal, Súmulas e Enunciados do tema. Em breve, iniciaremos a inclusão de decisões dos demais tribunais, a partir do STJ.
      </Description>
      <Content>
        <Form 
          initialSearch={initialSearch}
          submit={submit}
        />
        <Results 
          results={results?.results || firstData.results} 
          pagination={results?.pagination || firstData?.pagination} 
          submit={submit}
          onClick={(clicked) => {
            setClickedInfo(clicked);
            setIsModalOpen(true);
          }}
        />
      <Modal isModalOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        {clickedInfo.map(info => (
          <div key={info.title} ref={info.content}>
            <span>{info.title}</span>
            <section>{info.content}</section>
          </div>
        ))}
      </Modal>
      </Content>
      <Footer />
    </>
  );
}

export default Decisions;

const Content = styled(Container)`
  padding: 32px 0 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    flex-direction: column;
  }
`;